import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const EditItemForm = () => {
  const { id } = useParams(); // Get the item ID from the URL params
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    description: '',
    price: 0,
    condition: '',
    status: '',
    location: ''
  });

  const categories = [
    'Books',
    'Electronics',
    'Sports Equipment',
    'Clothing & Accessories',
    'Home & Kitchen Appliances',
    'Furniture',
    'Toys & Games',
    'Musical Instruments',
    'Tools & Equipment',
    'Outdoor Gear',
    'Arts & Crafts Supplies',
    'Beauty & Personal Care Products',
    'Health & Fitness Gear',
    'Stationery & Office Supplies',
    'Collectibles & Memorabilia'
];

  useEffect(() => {
    fetchItem();// eslint-disable-next-line
  }, []);

  const fetchItem = async () => {
    try {
      const response = await axios.get(`https://backend-alien.vercel.app/api/main/items/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem('userData')).authtoken}`,
        },
      });
      setFormData({
        title: response.data.item.title,
        category: response.data.item.category,
        description: response.data.item.description,
        price: response.data.item.price,
        condition: response.data.item.condition,
        status: response.data.item.status,
        location: response.data.item.location
      });
    } catch (error) {
      console.error('Error fetching item:', error.message);
    }
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://backend-alien.vercel.app/api/main/items/${id}`, formData, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem('userData')).authtoken}`,
        },
      });
      toast.success("Item Updated Successfully");
      navigate("/fetchitems");
    } catch (error) {
      console.error('Error updating item:', error.message);
      toast.error("Error Updating Item");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="container mx-auto">
      <h1 className="text-3xl font-semibold mb-8">Edit Item</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="title" className="block text-gray-800 font-semibold mb-2">Title</label>
          <input type="text" id="title" name="title" value={formData.title} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full" />
        </div>
        <div className="mb-4">
          <label htmlFor="category" className="block text-gray-800 font-semibold mb-2">Category</label>
          <select id="category" name="category" value={formData.category} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full">
            <option value="">Select a category</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>{category}</option>
            ))}
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="block text-gray-800 font-semibold mb-2">Description</label>
          <textarea id="description" name="description" value={formData.description} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full" />
        </div>
        <div className="mb-4">
          <label htmlFor="price" className="block text-gray-800 font-semibold mb-2">Price</label>
          <input type="number" id="price" name="price" value={formData.price} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full" />
        </div>
        <div className="mb-4">
          <label htmlFor="condition" className="block text-gray-800 font-semibold mb-2">Condition</label>
          <select id="condition" name="condition" value={formData.condition} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full">
            <option value="New">New</option>
            <option value="Used">Used</option>
            <option value="Refurbished">Refurbished</option>
            <option value="Like New">Like New</option>
            <option value="Good">Good</option>
            <option value="Fair">Fair</option>
            <option value="Poor">Poor</option>
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="status" className="block text-gray-800 font-semibold mb-2">Status</label>
          <select id="status" name="status" value={formData.status} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full">
            <option value="Available">Available</option>
            <option value="Unavailable">Unavailable</option>
            <option value="Borrowed">Borrowed</option>
            <option value="Sold">Sold</option>
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="location" className="block text-gray-800 font-semibold mb-2">Location</label>
          <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} className="px-4 py-2 border border-gray-300 rounded-md w-full" />
        </div>
        <div className="mb-4">
          <button type="submit" className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">Save Changes</button>
        </div>
      </form>
    </div>
  );
};

export default EditItemForm;
